import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'

import { generateStateKey } from '../../../../../../utilities/generateStateKey'
import { cl } from '../../../../../../utilities/cl'

import Collapsible from '../../../../../../components/Space/Collapsible'
import ScrollContainer from '../../../../../../components/ScrollContainer'
import List from '../../../../../../components/List'
import SvgArrowUpDown from '../../../../../../components/SVG/ArrowUpDown'
import SvgPlay from '../../../../../../components/SVG/Play'
import SvgPause from '../../../../../../components/SVG/Pause'
import { formatSecondsToTime } from '../../../../../../utilities/format'
import { duration } from 'moment'
import { store } from '../../../../../../connect'

const Song = ({
    className = "",
    selectedPlaylists,
    currentPlaylist,
    placeNumber,
    id,
    active,
    name,
    turn,
    cliptime,
    tempo,
    songauthor_name,
    hide_song_author_name,
    player_name,
    album_name,
    genre_name,
    year,
    variant,
    selected,
    markItems,
    trackPlaying,
    isMarkItems,
    isSelected,
    isPlaying,
    play,
    pause,
    stop,
    rewind,
    filename,
    //watcherInterval = null
    audio
}) => {



    let duration

    if (cliptime) {
        duration = cliptime.split(":").splice(1).join(":").split('.')?.[0] || ''
    }

    const [slider, setSlider] = useState(0);

    const [currentWatcherInterval, setCurrentWatcherInterval] = useState(null);

    useEffect(() => {
        if (isPlaying) {
            startWatch();
        } else {
            killWatcher();
        }

        return () => killWatcher();
    }, [isPlaying, audio]);


    function startWatch() {
        killWatcher(); // Сначала очищаем предыдущий интервал

        if (isPlaying && audio) {
            const interval = setInterval(() => {
                if (isPlaying) {
                    updateTime();
                }
            }, 50);
            setCurrentWatcherInterval(interval);
        }
    }

    function killWatcher(resetTime) {
        if (currentWatcherInterval) {
            clearInterval(currentWatcherInterval);
            setCurrentWatcherInterval(null);
        }
        updateTime(resetTime);
    }


    const updateTime = (resetTime) => {
        let currentTime = "00:00"


        if (resetTime !== true && (audio.current?.currentTime !== audio.current?.duration && isPlaying)) {
            // Время
            currentTime = formatSecondsToTime(audio.current?.currentTime)

            // Слайдер

            const sliderPercent = (audio.current?.currentTime / (audio.current?.duration / 100))
            setSlider(sliderPercent)
        }

    }

    const rewinds = (e) => {
        const rect = e.target.getBoundingClientRect()
        const clickPercent = 100 * (e.nativeEvent.offsetX / rect.width)
        const totime = clickPercent * 0.01
        console.log({ totime, audio });
        audio.current.currentTime = audio.current.duration * totime


    }
    function plays() {
        play({
            trackId: id,
            filename: filename,
            name,
            duration
        })
    }
    function pauses() {
        pause()
    }


    className = cl(
        className,
        // { "Playlist": [variant] },
        "selectable-item",
        { "Song": [variant] },
        { "selected": isSelected },
        { "highlighted": isMarkItems },
        { "playing": isPlaying },
        { "name-fade": slider === 100 },
    )



    return (


        <div className={className} data-song-id={id}>
            <header className="Song__header">
                <span className="rewind" data-playing={isPlaying} onClick={rewinds}></span>
                <span className={cl("slider-1", { "d-none": slider === 0 })} style={{ right: `${100 - slider}%` }}></span>
                <span className={cl("slider-2", { "d-none": slider === 0 })} style={{ right: `${100 - slider}%` }}></span>

                <div className="Songs__grid">
                    {/* <div className="number" data-song-id={ id }>
                        { turn }
                    </div> */}
                    <div className="id" data-song-id={id}>
                        {id}
                    </div>
                    <div className="play">
                        <span onClick={plays}>
                            <SvgPlay className="icon-play" variant="prim" size="xs1" title="Воспроизвести" />
                        </span>
                        <span onClick={pauses}>
                            <SvgPause className="icon-pause" variant="prim" size="xs1" title="Приостановить" />
                        </span>
                    </div>
                    <div className="composition" data-song-id={id}>
                        {/* <span style={ { marginRight: "10px" } } onClick={ plays }>
                            <SvgPlay variant="prim" size="xs1" />
                        </span> */}
                        <h4>{name}</h4>
                    </div>
                    <div className="duration" data-song-id={id}>
                        {duration}
                    </div>
                    <div className="temp" data-song-id={id}>
                        {tempo}
                    </div>
                    <div className="chill_out" data-song-id={id}>
                        {genre_name && genre_name.length > 17 ? `${genre_name.slice(0, 14)}…` : genre_name}
                    </div>
                    <div className="author" hidden data-song-id={id}>
                        {songauthor_name}
                    </div>
                    <div className="performer" hidden data-song-id={id}>
                        {player_name}
                    </div>
                    {/* <div className="album" data-song-id={ id }>
                        { album_name === "" && "Альбом не указан" }
                    </div> */}
                    <div className="added" data-song-id={id}>
                        {year}
                    </div>
                </div>
            </header>
        </div>


    )
}



export default Song